<template>
  <div>
    <div v-if="seasonType.seasonInfo" class="ticket-season">
<!--    <div class="ticket-season">-->
      <!--
      <div class="sub-top">
        <img src="@/assets/img/banner/ticket_info.png" alt="">
        <div class="container">
          <img src="@/assets/img/login_bg.png" alt="">
          <div class="title">
            <p>준비중입니다</p>
          </div>
        </div>
      </div>
      -->
      <div class="img-content">
        <img src="@/assets/img/ticket/jdfc_seasonticket_2026.jpeg" alt="seasonticket_2026">
        <a href="https://tickets.interpark.com/contents/bridge/25018698" target="_blank">
          <button class="reservations">구매하기</button>
        </a>
      </div>
    </div>
    <div v-else>
      <PageComingSoon :titleText="' '" :descriptionText="String(seasonMsg)" />
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import PageComingSoon from '@/components/Common/PageComingSoon';
export default {
  name: 'TicketSeasonInfo',
  components: {PageComingSoon},
  computed: {
    dayjs() {
      return dayjs
    }
  },
  data() {
    return {
      tabList: [],
      seasonType: this.$store.getters['getSeasonType'],
      seasonMsg: this.$store.getters['getSeasonMsg'],
    }
  },
  mounted () {
  },
  methods: {

  }
}
</script>
